/**
 * Amplience Connection Pool and Timeout Configuration
 *
 * PREVENTS SITE OUTAGES by limiting connections and failing fast
 * Used by: amplienceFetch, ContentClient SDK, and template fetches
 *
 * CONNECTION POOL:
 * • maxSockets: 50 - Max concurrent connections to Amplience
 * • maxFreeSockets: 20 - Keep 20 warm connections ready to use
 *
 * SOCKET TIMEOUTS:
 * • timeout: 8s - Close inactive sockets
 * • freeSocketTimeout: 4s - Close idle sockets to free resources
 *
 * REQUEST TIMEOUT:
 * • 8 seconds - Fail fast instead of hanging for 60+ seconds
 */
export const AMPLIENCE_HTTPS_OPTIONS = {
  maxSockets: 50,
  maxFreeSockets: 20,
  timeout: 8000,
  freeSocketTimeout: 4000,
} as const;

export const AMPLIENCE_REQUEST_TIMEOUT = 8000 as const;
